import { AnyAction, createSlice } from '@reduxjs/toolkit';
import * as actionTypes from './customerAreaActionTypes';
import {
  CustomerAreaState,
  RootState,
  Project,
} from '@greenkub-fronts/shared/interface';
import { setHilighNotification } from './useCases/hilightNotification/hilight-notification.use-case';
import { initCurrentProject } from './useCases/initCurrentProject/init-current-project.use-case';
import { editProcessOptions } from './useCases/editProcessOptions/edit-process-options.use-case';
import { persistProcessedOptions } from './useCases/persistProcessOptions/persist-processed-options.use-case';
import { setHeaderTitle } from './useCases/setHeaderTitle/set-header-title.use-case';

export const CUSTOMER_AREA_FEATURE_KEY = 'customerArea';

export const initialCustomerAreaState: CustomerAreaState = {
  currentProjectId: undefined,
  pageTitle: 'MON ESPACE CLIENT',
  hilightedNotificationId: null,
  processedOptions: {
    terrasse: false,
    pergola: false,
    bardage: false,
    toitureVege: false,
    menuiserieAnthra: false,
    accompagnement: false,
    aideDechargement: false,
    forfaitCoaching: false,
    tailleTerrasse: false,
    taillePergola: false,
    haveBeenTouch: false,
    isPersisting: false,
  },
};

export const customerAreaSlice = createSlice({
  name: CUSTOMER_AREA_FEATURE_KEY,
  initialState: initialCustomerAreaState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      initCurrentProject.fulfilled,
      (state, action: AnyAction) => {
        state.processedOptions = action['payload'].processedOptions;
      }
    );
    builder.addCase(
      actionTypes.SET_CURRENT_PROJECT,
      (state, action: AnyAction) => {
        state.currentProjectId = action['payload'].currentProjectId;
      }
    );
    builder.addCase(setHeaderTitle.fulfilled, (state, action: AnyAction) => {
      state.pageTitle = action['payload'].pageTitle;
    });
    builder.addCase(
      setHilighNotification.fulfilled,
      (state, action: AnyAction) => {
        state.hilightedNotificationId = action['payload'].newNotificationId;
      }
    );
    builder.addCase(
      editProcessOptions.fulfilled,
      (state, action: AnyAction) => {
        state.processedOptions = action['payload'].processedOptions;
      }
    );
    builder.addCase(persistProcessedOptions.pending, (state) => {
      state.processedOptions.isPersisting = true;
    });
    builder.addCase(persistProcessedOptions.fulfilled, (state) => {
      state.processedOptions.isPersisting = false;
      state.processedOptions.haveBeenTouch = false;
    });
  },
});

export const customerArea = customerAreaSlice.reducer;

export const getCurrentProject = (rootState: RootState) => {
  const query =
    rootState.api.queries[
      'getAllCustomerProjects({"groupName":"ProjectsForCustomerArea"})'
    ];

  if (query && query.status === 'fulfilled') {
    return query.data?.find(
      (project: Project) =>
        project.id === rootState[CUSTOMER_AREA_FEATURE_KEY].currentProjectId
    ) as Project;
  }

  return undefined;
};
